/**
 * @typedef {import('./Props').default} Props
 */

import ActionMessage from '../../../shared/ActionMessages/ActionMessage';
import React from 'react';
import { translate } from '../../../App/Internationalization';

/** @extends {React.Component<Props>} */
export default class ContactBulkTagPopup extends React.Component {
	/** @returns {JSX.Element} */
	#renderNoContactsError() {
		return (
			<ActionMessage
				action="error"
				onClose={this.props.onClose}
				title={translate('agent.pages.contacts.popup.header_error')}
			>
				<p
					// eslint-disable-next-line react/no-danger -- translation file uses html tags
					dangerouslySetInnerHTML={{
						__html: translate(
							'agent.pages.contacts.popup.no_contacts_selected'
						),
					}}
				/>
			</ActionMessage>
		);
	}

	/** @returns {JSX.Element} */
	#renderContent() {
		return (
			<section className="text-left">
				<p className="mb-4">
					{translate(
						'agent.pages.contacts.popup.bulk_tag_description'
					)}
				</p>

				<div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
					{(this.props.availableTags ?? []).map((tag) => (
						<label
							className="flex items-center gap-3"
							htmlFor={`bulk-contact-tag-${tag.id}`}
							key={tag.id}
						>
							<input
								checked={
									this.props.selectedTagIdsDraft?.includes(
										tag.id
									) ?? false
								}
								id={`bulk-contact-tag-${tag.id}`}
								onChange={() =>
									this.props.onTagToggle?.(tag.id)
								}
								type="checkbox"
							/>
							<span>
								{tag.name}
								{tag.isDefault
									? ` (${translate(
											'agent.pages.contacts.popup.default_tag'
									  )})`
									: ''}
							</span>
						</label>
					))}
				</div>
			</section>
		);
	}

	/** @returns {JSX.Element} */
	render() {
		if (!this.props.selectedContacts?.length) {
			return this.#renderNoContactsError();
		}

		return (
			<ActionMessage
				action="theme"
				onClose={this.props.onClose}
				onSubmit={this.props.onSubmit}
				submitTitle={translate(
					'agent.pages.contacts.popup.bulk_tag_confirm'
				)}
				title={translate('agent.pages.contacts.popup.bulk_tag_header')}
			>
				{this.#renderContent()}
			</ActionMessage>
		);
	}
}
